import React from "react";
import clsx from "clsx";
import "../../afs-walkthrough.css";
import WComponent from "../../../../../common/WComponent";

class BookkeepingView extends WComponent {
	state = {
		filterText: "",
		filterStatus: "all", // all, classified, unclassified
	};

	render() {
	let { transactions, classifications, onClassificationChange } = this.props;
	let { filterText, filterStatus } = this.state;

	if (!transactions || transactions.length === 0) {
		return <div className="afs-bookkeeping__empty">No transactions loaded.</div>;
	}

	let filtered = transactions;

	if (filterStatus === "classified") {
		filtered = filtered.filter(function (transaction) {
			return transaction.classification && transaction.classification !== "Unclassified";
		});
	} else if (filterStatus === "unclassified") {
		filtered = filtered.filter(function (transaction) {
			return !transaction.classification || transaction.classification === "Unclassified";
		});
	}

	if (filterText) {
		let search = filterText.toLowerCase();
		filtered = filtered.filter(function (transaction) {
			let description = (transaction.description || "").toLowerCase();
			let classification = (transaction.classification || "").toLowerCase();
			let bank = (transaction.bankAccountName || "").toLowerCase();
			return description.includes(search) || classification.includes(search) || bank.includes(search);
		});
	}

	let totalCount = transactions.length;
	let classifiedCount = transactions.filter(function (transaction) {
		return transaction.classification && transaction.classification !== "Unclassified";
	}).length;
	let unclassifiedCount = totalCount - classifiedCount;
	let classificationPercent = totalCount > 0 ? Math.round((classifiedCount / totalCount) * 100) : 0;

	// Merge any classification names from transactions that aren't already in the list
	let classificationSet = new Set((classifications || []).map(function (c) { return c.name; }));
	let merged = (classifications || []).slice();
	for (let tx of (transactions || [])) {
		let cls = tx.classification;
		if (cls && cls !== "Unclassified" && cls !== "uncategorized" && !classificationSet.has(cls)) {
			merged.push({ name: cls });
			classificationSet.add(cls);
		}
	}
	let sortedClassifications = merged.sort(function (a, b) {
		return (a.name || "").localeCompare(b.name || "");
	});

	return (
		<div className="afs-bookkeeping">
			<div className="afs-bookkeeping__header">
				<div className="afs-bookkeeping__stats">
					<span
						className={clsx("afs-bookkeeping__stat", filterStatus === "all" && "afs-bookkeeping__stat--active")}
						onClick={() => { this.update({ filterStatus: "all" }); }}
					>
						All ({totalCount})
					</span>
					<span
						className={clsx("afs-bookkeeping__stat", "afs-bookkeeping__stat--pass", filterStatus === "classified" && "afs-bookkeeping__stat--active")}
						onClick={() => { this.update({ filterStatus: "classified" }); }}
					>
						Classified ({classifiedCount})
					</span>
					<span
						className={clsx("afs-bookkeeping__stat", "afs-bookkeeping__stat--warn", filterStatus === "unclassified" && "afs-bookkeeping__stat--active")}
						onClick={() => { this.update({ filterStatus: "unclassified" }); }}
					>
						Unclassified ({unclassifiedCount})
					</span>
					<span className="afs-bookkeeping__percent">{classificationPercent}% complete</span>
				</div>
				<input
					className="afs-bookkeeping__search"
					type="text"
					placeholder="Search transactions..."
					value={filterText}
					onChange={(event) => { this.update({ filterText: event.target.value }); }}
				/>
			</div>

			<div className="afs-bookkeeping__table-wrap">
				<table className="afs-bookkeeping__table">
					<thead>
						<tr>
							<th className="afs-bookkeeping__col-date">Date</th>
							<th>Description</th>
							<th className="afs-bookkeeping__col-bank">Bank</th>
							<th className="afs-bookkeeping__col-amount">Amount</th>
							<th className="afs-bookkeeping__col-class">Classification</th>
						</tr>
					</thead>
					<tbody>
						{filtered.map(function (transaction, transactionIndex) {
							let isUnclassified = !transaction.classification || transaction.classification === "Unclassified";

							return (
								<tr key={transactionIndex} className={clsx(isUnclassified && "afs-bookkeeping__row--unclassified")}>
									<td>{transaction.date}</td>
									<td className="afs-bookkeeping__desc">{transaction.description}</td>
									<td className="afs-bookkeeping__bank">{transaction.bankAccountName || "—"}</td>
									<td className={clsx("afs-bookkeeping__amount", transaction.amount < 0 && "afs-bookkeeping__amount--negative")}>
										{transaction.amount != null ? Number(transaction.amount).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "—"}
									</td>
									<td>
										<select
											className={clsx("afs-bookkeeping__select", isUnclassified && "afs-bookkeeping__select--empty")}
											value={transaction.classification || ""}
											onChange={function (event) {
												if (onClassificationChange) {
													onClassificationChange(transaction, event.target.value);
												}
											}}
										>
											<option value="">Unclassified</option>
											{sortedClassifications.map(function (classification) {
												return (
													<option key={classification.name} value={classification.name}>
														{classification.name}
													</option>
												);
											})}
										</select>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
		</div>
	);
	}
}

export default BookkeepingView;
